import FolderAddOrUpdateContent from "../content/folderAddOrUpdateContent";
import Layout from "../layout/Layout";

const EventsAddOrUpdate = () => {
  return (
    <Layout>
      {" "}
      <FolderAddOrUpdateContent />
    </Layout>
  );
};

export default EventsAddOrUpdate;
